import Input from '../../../../../Core/Fields/Floating/Input';
import SelectSearchApi from '../../../../../Core/Fields/Floating/SelectSearchApi';

const MoreInfoTab = ({formData, onFieldChange,salesPartnerData }) => {
    console.log("formDataformDataformDataformDataformDataformData",formData);
    return (
        <div>
            <div className="px-2 py-3" style={{ background: 'white' }}>
                <div style={{ display: 'flex', gap: '15px' }} >
                    
                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Accounting Details</p>
                                </div>
                            </div>
                            
                            <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
                                <div style={{ flex: 1 }}>
                                    {/* <SelectSearchApi
                                        label="Customer Address"
                                        list={addressData.billingAddress_List}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        value={formData.billing_address}
                                        onChange={(e) => onFieldChange('billing_address', e)}
                                        onApiChange={(e) => addressData.refetch_billingAddress(e)}
                                    /> */}
                                     <Input
                                                                            label="Debit To"
                                                                            style={{ height: "30px" }}
                                                                            value={formData?.debit_to}
                                                                            readOnly
                                                                        />
                                </div>

                                <div style={{ flex: 1 }}>

                                     <SelectSearchApi
                                        label="is Opening Entry"
                                        list={[{value:'No'},{value:'Yes'}]}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        value={formData.is_opening_entry}
                                        onChange={(e) => onFieldChange('is_opening_entry', e)}
                                        onApiChange={(e) => {}}
                                    />
                                </div>

                                 
                            </div>

                           
                        </div>
                    </div>

                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            
                            <div style={{ display: 'flex', gap: '15px'}}>
                                <div style={{ flex: 1 }}>
                                    <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Commission</p>
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
                                <div style={{ flex: 1 }}>  

                                      <SelectSearchApi
                                        label="Sales Partner"
                                        list={salesPartnerData.sales_Partner_List}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        value={formData.sales_partner}
                                        onChange={(e) => onFieldChange('sales_partner', e)}
                                        onApiChange={(e) => salesPartnerData.refetch_sales_partner(e)}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                     <Input             label="Commission Rate (%)"
                                                        style={{ height: "30px" }}
                                                        value={formData.commission_rate}
                                                         onChange={(e) => onFieldChange('commission_rate', e.target.value)}
                                                        //  readOnly
                                                        />
                                     {/* <SelectSearchApi
                                        label="Commission Rate (%)"
                                        list={companyContactPersonData.companyContactPerson_List}
                                        getOptionLabel={(item) => item.label}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        value={formData.commission_rate}
                                        onChange={(e) => onFieldChange('commission_rate', e)}
                                        onApiChange={(e) => companyContactPersonData.refetch_company_Address_Person(e)}
                                    /> */}
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
                                <div style={{ flex: 1 }}>  
                                       <Input             
                                                        style={{ height: "30px" }}
                                                                label="Amount Eligible for Commission"
                                        value={formData.amount_eligible_for_commission}
                                        onChange={(e) => onFieldChange('amount_eligible_for_commission', e.target.value)}
                                                         readOnly
                                                        />
                                      {/* <SelectSearchApi
                                        list={shippingDispatchAddressData.shipping_dispatch_address_List}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        label="Amount Eligible for Commission"
                                        value={formData.amount_eligible_for_commission}
                                        onChange={(e) => onFieldChange('amount_eligible_for_commission', e)}
                                        onApiChange={(e) => shippingDispatchAddressData.refetch_shipping_dispatch_address(e)}
                                    /> */}
                                </div>
                                <div style={{ flex: 1 }}>

                                    <Input             
                                                        style={{ height: "30px" }}
                                                               label="Total Commission"
                                        value={formData.total_commission}
                                        onChange={(e) => onFieldChange('total_commission', e.target.value)}
                                                         readOnly
                                                        />
                                     {/* <SelectSearchApi
                                        list={companyContactPersonData.companyContactPerson_List}
                                        getOptionLabel={(item) => item.label}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        label="Total Commission"
                                        value={formData.total_commission}
                                        onChange={(e) => onFieldChange('total_commission', e)}
                                        onApiChange={(e) => companyContactPersonData.refetch_company_Address_Person(e)}
                                    /> */}
                                </div>
                            </div>

                         

                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default MoreInfoTab;